import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';
import {combineReducers} from 'redux';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {Configuration} from 'configuration';
import advancedSearchItemsSlice from '../services/advancedSearchItems/reducer';
import advancedSearchViewModeSlice from '../services/advancedSearchViewMode/reducer';
import agentItemsSlice from '../services/agentItems/reducer';
import bulkUpdateItemsSlice from '../services/bulkUpdateItems/reducer';
import codelistsSlice from '../services/codelists/codelistsSlice';
import headSlice from '../services/head/headSlice';
import metadataEditSlice from '../services/metadata/metadataEditSlice';
import receivedItemsSlice from '../services/receiveItems/receivedItemsSlice';
import settingsSlice from '../services/settings/settingsSlice';
import thesaurusSlice from '../services/thesaurus/thesaurusSlice';
import workItemsSlice from '../services/workItems/workItemsSlice';
import {ebsApi} from './ebsApi';

const reducers = {
  [ebsApi.reducerPath]: ebsApi.reducer,
  [settingsSlice.name]: settingsSlice.reducer,
  [headSlice.name]: headSlice.reducer,
  [codelistsSlice.name]: codelistsSlice.reducer,
  [thesaurusSlice.name]: thesaurusSlice.reducer,
  [metadataEditSlice.name]: metadataEditSlice.reducer,
  [receivedItemsSlice.name]: receivedItemsSlice.reducer,
  [bulkUpdateItemsSlice.name]: bulkUpdateItemsSlice.reducer,
  [advancedSearchItemsSlice.name]: advancedSearchItemsSlice.reducer,
  [workItemsSlice.name]: workItemsSlice.reducer,
  [agentItemsSlice.name]: agentItemsSlice.reducer,
  [advancedSearchViewModeSlice.name]: advancedSearchViewModeSlice.reducer,
};
const rootReducer = combineReducers(reducers);

const whitelist: string[] = [
  settingsSlice.name,
  bulkUpdateItemsSlice.name,
  workItemsSlice.name,
  agentItemsSlice.name,
  advancedSearchViewModeSlice.name,
];

const persistConfig = {
  key: 'ebba',
  storage,
  whitelist,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: Configuration.env === 'local',
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: {warnAfter: 101},
      serializableCheck: {
        warnAfter: 100,
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(ebsApi.middleware),
});

setupListeners(store.dispatch);

const persistor = persistStore(store);

export default {store, persistor};
